module.exports = "/static/assets/17b33f2648d26f48eab60613d2829787.png";